import axios from "axios";
const jsonConfig = require("../../Config.json");

const addSkillSubSkillStructureResponse = async (payload) => {
    let allSkillsList = {}
    try {
        const getallskillresponse = await axios.post(
            jsonConfig.apiUrl + "skillsubskillstructure",
            payload,
            {
                headers: {
                    "x-functions-key": jsonConfig.key,
                },
            });
        allSkillsList = getallskillresponse;

        return Promise.resolve(allSkillsList)
    }
    catch (error) {
        return Promise.reject(error)
    }
}

export default addSkillSubSkillStructureResponse;